import React from 'react';
import PT from 'prop-types';
import { Box } from '@procore/core-react';
import styled from 'styled-components';

const ScrollableBody = styled(Box)`
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  min-height: 0;
  height: auto;
`;

export const MobileOverlayBody = ({ children }) => (
  <ScrollableBody>{children}</ScrollableBody>
);

MobileOverlayBody.propTypes = {
  children: PT.node.isRequired,
};
